import { React, createContext, useState } from "react";

export const ContactsContext = createContext();
const filterList = [
  {
    id: "today",
    label: "Today",
  },
  {
    id: "yesterday",
    label: "Yesterday",
  },
  {
    id: "thisweek",
    label: "ThisWeek",
  },
  {
    id: "alltime",
    label: "AllTime",
  },
];
const Dummy_contacts = [
  {
    id: 1,
    name: "Muhammad",
    phoneNumber: "00000000000",
    date: "2023-10-04",
    email: "muhammad@gmail.com",
    message: "Hello Muhammad",
    companyName: "20th Letter",
  },
  {
    id: 2,
    name: "Zubair",
    phoneNumber: "00000000000",
    date: "2023-10-3",
    email: "zubair@gmail.com",
    message: "Hello zubair",
    companyName: "20th Letter",
  },
  {
    id: 3,
    name: "Iqbal",
    phoneNumber: "00000000000",
    date: "2023-09-04",
    email: "iqbal@gmail.com",
    message: "Hello iqbal",
    companyName: "20th Letter",
  },
];

export default function ContactsContextProvider({ children }) {
  const [clickedUser, setClickedUser] = useState(null);
  const [filter, setFilter] = useState("Today");
  const OnClickedUser = Dummy_contacts.filter((item) => {
    return item.id === clickedUser;
  });

  const varifyId = (Id) => {
    if (OnClickedUser[0]?.id === Id) {
      return true;
    } else return false;
  };

  const filterContacts = (filterText) => {
    switch (filterText) {
      case "Today":
        const today = new Date();
        return Dummy_contacts.filter((item) => {
          const itemDate = new Date(item.date);
          return (
            itemDate.getDate() === today.getDate() &&
            itemDate.getMonth() === today.getMonth() &&
            itemDate.getFullYear() === today.getFullYear()
          );
        });

      case "Yesterday":
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return Dummy_contacts.filter((item) => {
          const itemDate = new Date(item.date);
          return (
            itemDate.getDate() === yesterday.getDate() &&
            itemDate.getMonth() === yesterday.getMonth() &&
            itemDate.getFullYear() === yesterday.getFullYear()
          );
        });

      case "ThisWeek":
        const newtoday = new Date();
        const startOfWeek = new Date(newtoday);
        startOfWeek.setDate(newtoday.getDate() - newtoday.getDay());

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);

        return Dummy_contacts.filter((item) => {
          const itemDate = new Date(item.date);
          return itemDate >= startOfWeek && itemDate <= endOfWeek;
        });

      case "AllTime":
        return Dummy_contacts;

      default:
        return Dummy_contacts;
    }
  };

  const filteredUser = filterContacts(filter);

  return (
    <ContactsContext.Provider
      value={{
        Dummy_contacts,
        clickedUser,
        setClickedUser,
        OnClickedUser,
        setFilter,
        filteredUser,
        filter,
        filterList,
        varifyId,
      }}
    >
      {children}
    </ContactsContext.Provider>
  );
}
